<template>
  <fragment>
    <v-layout
      wrap
      align-content-center
      class="mb-1"
    >
      <v-flex
        xs12
        md5
      >
        <v-select
          v-model="form.values.visitType"
          :items="visitTypeList"
          :label="$t('appointment.visitType')"
          :no-data-text="$t('messages.noDataAvailable')"
          :error-messages="getRequiredErrors(form.errors.visitType)"
          item-text="name"
          item-value="id"
          @change="$emit('updateVisitTimes')"
        />
      </v-flex>
      <v-spacer />
      <v-flex
        xs12
        md5
      >
        <v-text-field
          v-model="form.values.date"
          :label="$t('appointment.date')"
          :error-messages="getRequiredErrors(form.errors.date)"
          type="date"
          @change="$emit('updateVisitTimes')"
        />
      </v-flex>
    </v-layout>
    <AppointmentDatePicker
      :date="form.values.date"
      :form="form"
      @updateVisitTimes="$emit('updateVisitTimes')"
    />
    <v-layout fill-height>
      <AppointmentHours
        :form="form"
        :data="visitTimeList"
        :date="form.values.date"
        :visit-type="form.values.visitType"
        @isFormValid="value => $emit('isFormValid', value)"
      />
    </v-layout>
    <v-layout justify-center>
      <v-flex
        md5
        xs12
      >
        <v-text-field
          v-model="form.values.description"
          class="visit-description mb-2"
          :label="$t('appointment.description')"
        />
      </v-flex>
    </v-layout>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { mapState } from 'vuex'
import { VISIT_TYPE_LIST_KEY, VISIT_TIME_LIST_KEY } from '../../../store/types/appointment.types'
import AppointmentHours from './AppointmentHours'
import AppointmentDatePicker from './AppointmentDatePicker'

export default {
  name: 'AppointmentForm',
  components: {
    AppointmentHours,
    AppointmentDatePicker,
    Fragment,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      visitTypeList: state => state.appointment[VISIT_TYPE_LIST_KEY],
      visitTimeList: state => state.appointment[VISIT_TIME_LIST_KEY],
    }),
  },
  methods: {
    getRequiredErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      return errors
    },
  },
}
</script>

<style scoped>
  .visit-description {
    padding-top: 4px;
  }
</style>
